var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.17006 5.28995L5.41006 1.04995C5.59782 0.860636 5.85342 0.75415 6.12006 0.75415C6.38669 0.75415 6.64229 0.860636 6.83006 1.04995C7.21778 1.43999 7.21778 2.06991 6.83006 2.45995L3.29006 5.99995L6.83006 9.53995C7.21778 9.92999 7.21778 10.5599 6.83006 10.9499C6.64134 11.1371 6.38586 11.2415 6.12006 11.2399C5.85425 11.2415 5.59878 11.1371 5.41006 10.9499L1.17006 6.70995C0.980744 6.52218 0.874259 6.26659 0.874259 5.99995C0.874259 5.73331 0.980744 5.47772 1.17006 5.28995Z","fill":"white"}));
}

ArrowLeft.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
